import { FORM_TYPES } from '../../../../types/paramsConfig.js';
import { WRAPPER_TYPES, } from '../../wrapperContext/wrapperContextSlice.js';
/**
 * Skip redirect when it's already handled by tracking events or other flows.
 * Cases: Google/LinkedIn success, registration success, CV upload modal.
 */
export const shouldSkipRedirect = ({ activeWrapper, activeView, showRegistrationSuccessfulModal, }) => {
    if (activeView === FORM_TYPES.GOOGLE_SUCCESS ||
        activeView === FORM_TYPES.LINKEDIN_RESPONSE_PAGE) {
        return true;
    }
    if (activeView === FORM_TYPES.REGISTRATION_SUCCESS) {
        return true;
    }
    if ((activeWrapper === WRAPPER_TYPES.MODAL ||
        activeWrapper === WRAPPER_TYPES.STEP_MODAL) &&
        showRegistrationSuccessfulModal) {
        return true;
    }
    return false;
};
//# sourceMappingURL=index.js.map